import request from '@/utils/request'
// 产品列表 productlist
export function productlist(data) {
  return request({
    url: '/api/baseinfo/product/list',
    method: 'post',
    data
  })
}
export function productdel(data) { // 产品删除
  return request({
    url: '/api/baseinfo/product/del',
    method: 'post',
    data
  })
}
// 产品新增页 productaddedit
export function productadd(data) {
  return request({
    url: '/api/baseinfo/product/add',
    method: 'post',
    data
  })
}
// 产品修改
export function productedit(data) {
  return request({
    url: '/api/baseinfo/product/edit',
    method: 'post',
    data
  })
}
// 查询产品信息详情
export function shortcode(query) {
  return request({
    url: '/api/baseinfo/product/shortcode',
    method: 'get',
    params: query
  })
}
// 图片上传
export function productupLoad(data,params) {
  return request({
    url: '/api/baseinfo/product/upLoad',
    method: 'post',
    data,
    params
  })
}
// 图片下载
export function downloadbypic(query) {
  return request({
    url: '/api/baseinfo/product/download',
    method: 'get',
    params: query
  })
}
export function downloadbycode(query) {
  return request({
    url: '/api/baseinfo/product/downloadbycode',
    method: 'get',
    params: query
  })
}
export function details(query) {
  return request({
    url: '/api/baseinfo/product/details',
    method: 'get',
    params: query
  })
}
// 产品分类productsort
export function productTree(query) {
  return request({
    url: '/api/baseinfo/brand/list',
    method: 'get',
    params: query
  })
}
export function treeadd(data) {
  return request({
    url: '/api/baseinfo/brand/add',
    method: 'post',
    data
  })
}
export function treeupdate(data) {
  return request({
    url: '/api/baseinfo/brand/update',
    method: 'post',
    data
  })
}
export function treedelete(data) {
  return request({
    url: '/api/baseinfo/brand/delete',
    method: 'post',
    data
  })
}
// 客户信息 新增
export function organizadd(data) {
  return request({
    url: '/baseinfo/api/organiz/push',
    method: 'post',
    data
  })
}
// 客户信息 修改
export function organizupdate(data) {
  return request({
    url: '/baseinfo/api/organiz/update',
    method: 'post',
    data
  })
}
// 客户信息 删除
export function organizdelete(data) {
  return request({
    url: '/baseinfo/api/organiz/delete',
    method: 'post',
    data
  })
}
// 原料信息 添加
export function materialadd(data) {
  return request({
    url: '/api/baseinfo/material/add',
    method: 'post',
    data
  })
}
// 原料信息 修改
export function materialedit(data) {
  return request({
    url: '/api/baseinfo/material/edit',
    method: 'post',
    data
  })
}
// 原料信息 删除
export function materialdelete(data) {
  return request({
    url: '/api/baseinfo/material/del',
    method: 'post',
    data
  })
}
// 原料信息 查询
export function materialdetails(query) {
  return request({
    url: '/api/baseinfo/material/details',
    method: 'get',
    params: query
  })
}
// 原料信息 分页列表
export function materialpagelist(query) {
  return request({
    url: '/api/baseinfo/material/pagelist',
    method: 'get',
    params: query
  })
}
// 查询产品扩展属性分页列表
export function productextendpagelist(query) {
  return request({
    url: '/api/baseinfo/productextend/pagelist',
    method: 'get',
    params: query
  })
}
// 添加产品扩展属性信息
export function productextendadd(data) {
  return request({
    url: '/api/baseinfo/productextend/add',
    method: 'post',
    data
  })
}
// 修改产品扩展属性信息
export function productextendedit(data) {
  return request({
    url: '/api/baseinfo/productextend/edit',
    method: 'post',
    data
  })
}
// 删除产品扩展属性信息
export function productextenddel(data) {
  return request({
    url: '/api/baseinfo/productextend/del?id=' + data,
    method: 'post',
    data
  })
}
// 查询包装单位信息分页列表
export function productunitpagelist(query) {
  return request({
    url: '/api/baseinfo/productunit/pagelist',
    method: 'get',
    params: query
  })
}
// 查询包装单位信息分页列表
export function productunitlist(query) {
  return request({
    url: '/api/baseinfo/productunit/list',
    method: 'get',
    params: query
  })
}
// 删除包装单位信息
export function productunitdel(data) {
  return request({
    url: '/api/baseinfo/productunit/del?id=' + data,
    method: 'post',
    data
  })
}
// 添加包装单位信息
export function productunitadd(data) {
  return request({
    url: '/api/baseinfo/productunit/add',
    method: 'post',
    data
  })
}
// 修改包装单位信息
export function productunitedit(data) {
  return request({
    url: '/api/baseinfo/productunit/edit',
    method: 'post',
    data
  })
}
// 产品层级关系树形展开
export function packgetree(query) {
  return request({
    url: '/api/baseinfo/packgetree/tree',
    method: 'get',
    params: query
  })
}
//包装关系列表
export function packgetlist(query) {
  return request({
    url: '/api/baseinfo/packgetree/list',
    method: 'get',
    params: query
  })
}
// 产品层级关系添加
export function packgetreeadd(data) {
  return request({
    url: '/api/baseinfo/packgetree/add',
    method: 'post',
    data
  })
}
// 产品层级关系修改
export function packgetreeedit(data) {
  return request({
    url: '/api/baseinfo/packgetree/edit',
    method: 'post',
    data
  })
}
// 产品层级关系删除
export function packgetreedel(data) {
  return request({
    url: '/api/baseinfo/packgetree/del?uuid=' + data,
    method: 'post',
    data
  })
}
// 委外客户列表
export function entrustlist(query) {
  return request({
    url: '/api/baseinfo/entrust/pagelist',
    method: 'get',
    params: query
  })
}
// 委外客户新增
export function entrustadd(data) {
  return request({
    url: '/api/baseinfo/entrust/add',
    method: 'post',
    data
  })
}
// 委外客户修改
export function entrustupdate(data) {
  return request({
    url: '/api/baseinfo/entrust/update',
    method: 'post',
    data
  })
}
// 委外客户删除
export function entrustdelete(data) {
  return request({
    url: '/api/baseinfo/entrust/delete',
    method: 'post',
    data
  })
}
// 生码URL
export function buildcodeurllist(query) {
  return request({
    url: '/api/baseinfo/sysconfig/buildcodeurllist',
    method: 'get',
    params: query
  })
}
// 
export function maxlevelproduct(query) {
  return request({
    url: '/api/baseinfo/packgetree/maxlevelproduct',
    method: 'get',
    params: query
  })
}
// 供应商查询原料查询
export function supplierlist(query) {// 供应商查询
  return request({
    url: '/api/baseinfo/material/supplierlist',
    method: 'get',
    params: query
  })
}
export function materiallist(query) {// 原料查询
  return request({
    url: '/api/baseinfo/material/materiallist',
    method: 'get',
    params: query
  })
}